<template>
  <div>
    <v-form ref="form">
      <v-file-input
        label="Selecionar arquivo"
        :class="[[color], ['ml-2 mb-1']]"
        accept="image/jpg, image/png, image/jpeg, application/pdf" 
        v-model="file"
        :hide-input="hide_input"
        @change="createLocalUrlFile()"
        :rules="[validateFormat]">
    </v-file-input>
    </v-form>
    <dialog-loading loadingText="Salvando anexo" v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import Api from '@/api/index'
export default {
  name: 'FileInput',
  props: {
    hide_input: {
      type: Boolean,
      default: false
    },
    wait_input:{
      type: Boolean,
      default: true
    },
    update_infos: {
      type: Object,
      default: {
        MODEL: '',
        id: ''
      }
    },
    attribute_name:{
      type: String,
      default: "attached_file"
    },
    color: {
      type: String,
      default: ""
    },
    is_creating: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      file: null,
      saving: false,
      validateFormat:  v => ["image/png", "application/pdf", "image/jpeg"].includes(v?.type) || "Formato inválido. Permitidos: JPG, JPEG, PNG, PDF"
    }
  },
  methods:{
    createLocalUrlFile(){
      if(this.file){
        var url  = window.URL.createObjectURL(this.file)
        let local_file_preview = {
          url: url,
          name: this.file.name,
          type: this.file.type,
        }
        this.$emit("filePreview", local_file_preview)
      }else{
        this.$emit("filePreview", null)
      }
      if(!this.wait_input){
        this.updateFile()
      }
    },
    pdfIsComplete(file) {
      const tailSize = Math.min(file.size, 4096)
      return file.slice(file.size - tailSize).arrayBuffer().then((buffer) => {
        const text = new TextDecoder('latin1').decode(buffer)
        return text.includes('%%EOF')
      })
    },
    prepareFormData(id){
      const formData = new FormData()
      let data = this.update_infos.MODEL.toLowerCase()
      
      if(this.is_creating){
        formData.append(`${data}[id]`, parseInt(id));
      }else{
        formData.append(`${data}[id]`, parseInt(this.update_infos.id));
      }
      formData.append(`${data}[${this.attribute_name}]`, this.file);

      return formData
    },
    deleteFile(){
      this.file = null
    },
    updateFile(id){
      if(this.file && this.$refs.form.validate()){
        const file = this.file
        const isPdf = file.type === 'application/pdf' || String(file.name || '').toLowerCase().endsWith('.pdf')
        const upload = () => {
        this.saving = true
        let form_data = this.prepareFormData(id)

        return Api[this.update_infos.API || this.update_infos.MODEL]['updateWithFormData'](form_data).then((r)=>{
          let local_file_preview = {
            url: null,
            name: this.file.name
          }
          local_file_preview.url = r.data?.data?.attributes?.attached_file_url || r.data?.[`${this.attribute_name}_url`]
          this.$emit("filePreview", local_file_preview)
          this.addNotification({type: 'success', msg: 'Arquivo anexado com sucesso.'})
          this.$emit('newFileUrl', {url: r.data?.data?.attributes?.attached_file_url || r.data?.[`${this.attribute_name}_url`], id: r.data?.data?.attributes?.id || r.data?.id})
        }).catch((err)=>{
          console.log(err)
          this.addNotification({type: 'error', msg: 'O anexo não foi salvo, tente editar e altera-lo novamente.'})
        }).finally(()=>{
          this.saving = false
          this.$emit('done')
        })
        }

        if (!isPdf) return upload()

        return this.pdfIsComplete(file).then((complete) => {
          if (complete) return upload()
          this.addNotification({type: 'error', msg: 'O PDF está incompleto e não pode ser aberto. Envie o arquivo novamente.'})
          this.$emit('noFile')
          return Promise.resolve()
        })
      }else{
        this.$emit('noFile')
        return Promise.resolve()
      }
    },
  }
}
</script>

<style scoped>
.red-color::v-deep .v-icon {
  color: red !important;
}
.green-color::v-deep .v-icon {
  color: #4CAF50 !important;
}
</style>